import * as yup from "yup";
export const CreateTaskSchema = yup.object().shape({
  name: yup.string().required("Required"),
  description: yup.string(),
  assignTo: yup.array(),
  deadline: yup.string(),
  status: yup.string(),
  feedback: yup.string(),
  taskType: yup.string().required("Required"),
  startDate: yup.date(),
  frequency: yup.string(),
  frequencyType: yup.string(),
  remarks: yup.string(),
  generatedBy: yup.string(),
  uploadImage: yup.string(),
  endDate: yup.string(),
  priority: yup.string(),
  weekDays: yup.string(),
  taskDifficulty: yup.string(),
});
